var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PayUCheckoutForm',{attrs:{"amount":_vm.amount,"description":_vm.description,"customer-email":_vm.customerInfo.email,"customer-first-name":_vm.customerInfo.firstName,"customer-last-name":_vm.customerInfo.lastName,"customer-phone":_vm.customerInfo.phone,"currency":_vm.currency}})
}
var staticRenderFns = []

export { render, staticRenderFns }